import { render, staticRenderFns } from "./AddWorks.vue?vue&type=template&id=da732014&scoped=true"
import script from "./AddWorks.vue?vue&type=script&lang=js"
export * from "./AddWorks.vue?vue&type=script&lang=js"
import style0 from "./AddWorks.vue?vue&type=style&index=0&id=da732014&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da732014",
  null
  
)

export default component.exports